import styled, { css } from 'styled-components';
import { color, gutter, responseFont } from '../../styles/mixins';
import { caps12 } from '../../styles/typography';

const Overflow = styled.div`
  overflow-x: auto;
  margin: 0 ${gutter(-2)};
`;

const Host = styled.div<{ divider?: boolean }>`
  display: flex;
  flex-direction: row;
  box-shadow: inset 0 -1px 0 0 ${color('gray30')};
`;

export const TabItem = styled.button<{ active?: boolean }>`
  ${caps12}
  ${responseFont(12, 13)}
  color: ${color('gray80')};
  transition: 0.18s ease-in-out;
  transition-property: color, border-bottom-color;
  padding: 22px 0;
  margin: 0 12px;
  text-transform: uppercase;

  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: transparent;

  white-space: pre;

  &:hover {
    color: ${color('navy100')};
  }

  ${(props) =>
    props.active &&
    css`
      color: ${color('navy100')};
      border-bottom-color: ${color('navy100')};
    `}
`;

interface TabBarProps {
  children?: React.ReactNode;
  divider?: boolean;
}

export function TabBar({ children, divider }: TabBarProps) {
  return (
    <Overflow>
      <Host divider={divider}>{children}</Host>
    </Overflow>
  );
}
